// GoogleMapComponent.tsx
import React, { useState } from 'react'
import { APIProvider, Map } from '@vis.gl/react-google-maps'

import MapHandler from './MapHandler'
import MapClickHandler from './MapClickHandler' // Import the new component
import './GoogleMap.css'
import { ClinicDetails } from '@dataTypes/location.type'
import { PlaceAutocompleteClassic } from './AutoCompleteField'
import { getEnv } from '@utils/env'

type GoogleMapComponentProps = {
  formData: ClinicDetails
  handleChange: (
    field: string,
    value: string | boolean | number | google.maps.LatLngLiteral,
  ) => void
  validationErrors: { [key: string]: string }
}

const API_KEY = getEnv('REACT_APP_GOOGLE_MAPS_API_KEY')

export const GoogleMapComponent = ({
  formData,
  handleChange,
  validationErrors,
}: GoogleMapComponentProps): React.ReactElement => {
  const [selectedPlace, setSelectedPlace] =
    useState<google.maps.places.PlaceResult | null>(null)
  const [selectedLocation, setSelectedLocation] =
    useState<google.maps.LatLng | null>(null)

  return (
    <APIProvider apiKey={API_KEY} libraries={['places', 'geocoding']}>
      <PlaceAutocompleteClassic
        onPlaceSelect={setSelectedPlace}
        handleChange={handleChange}
        formData={formData}
        validationErrors={validationErrors}
      />
      <Map
        style={{
          width: '100%',
          height: '250px',
          marginTop: '8px',
        }}
        defaultZoom={3}
        defaultCenter={{ lat: 22.54992, lng: 0 }}
        gestureHandling={'greedy'}
        disableDefaultUI={false}
        fullscreenControl={true}
        streetViewControl={false}
        mapTypeControl={false}
      >
        <MapHandler
          place={selectedPlace}
          location={selectedLocation}
          coordinates={formData.coordinates}
        />
        <MapClickHandler
          handleChange={handleChange}
          setSelectedLocation={setSelectedLocation}
        />
      </Map>
    </APIProvider>
  )
}
